export default __webpack_public_path__ + "static/media/icon_top.fa8f3f41.png";